import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';

// Omnium UI
import { OuiAccordionModule } from 'omnium-ui/accordion';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiButtonToggle } from 'omnium-ui/button-toggle';
import { OuiChipModule } from 'omnium-ui/chip';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiDocumentViewer } from 'omnium-ui/document-viewer';
import { OuiErrorPageComponent } from 'omnium-ui/error-page';
import { OuiEtatVide } from 'omnium-ui/etat-vide';
import {
  OuiAutocomplete,
  OuiCheckbox,
  OuiRadioButton,
  OuiRadioButtonGroup,
  OuiSelect,
  OuiTextarea,
  OuiTextfield,
} from 'omnium-ui/form-field';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLayoutModule, OuiNavButtonModule, OuiNavigationPanelModule } from 'omnium-ui/layout';
import { OuiLoadingModule } from 'omnium-ui/loading';
import { OuiMenuModule } from 'omnium-ui/menu';
import { OuiNumber } from 'omnium-ui/number';
import { OuiPaginatorModule } from 'omnium-ui/paginator';
import { OuiPairInfo } from 'omnium-ui/pair-info';
import { OuiSearchbar } from 'omnium-ui/searchbar';
import { OuiSelectFilter } from 'omnium-ui/select-filter';
import { OuiSlideToggle } from 'omnium-ui/slide-toggle';
import { OuiSnackbarModule } from 'omnium-ui/snackbar';
import { OuiStepper } from 'omnium-ui/stepper';
import { OuiTableModule } from 'omnium-ui/table';
import { OuiTabsModule } from 'omnium-ui/tabs';
import { OuiTagModule } from 'omnium-ui/tag';
import { OuiTooltipModule } from 'omnium-ui/tooltip';

import { OuiBanner } from 'omnium-ui/banner';
import { OuiInfosBulle } from 'omnium-ui/infos-bulle';
import { LandingPageComponent } from 'projects/fiche-conseil-lib/src/lib/components/landing-page/landing-page.component';
import { SearchEnveloppeProduitAutocompleteComponent } from 'projects/fiche-conseil-lib/src/lib/components/search-enveloppe-produit-autocomplete/search-enveloppe-produit-autocomplete.component';
import { StepperFooterComponent } from 'projects/fiche-conseil-lib/src/lib/components/stepper-footer/stepper-footer.component';
import { UnauthorizedComponent } from 'projects/fiche-conseil-lib/src/lib/components/unauthorized/unauthorized.component';
import { NavPanelComponent } from 'projects/fiche-conseil-lib/src/lib/nav-panel/nav-panel.component';
import { SafeResourceUrlPipe } from 'projects/fiche-conseil-lib/src/lib/safe-resource-url.pipe';
import { ConfirmationSimpleComponent } from './components/confirmation-simple/confirmation-simple.component';
import { DocumentViewerPanelComponent } from './components/document-viewer/document-viewer-panel/document-viewer-panel.component';
import { FicheConseilStatutTagComponent } from './components/fiche-conseil-statut-tag/fiche-conseil-statut-tag.component';
import { SearchCommandeAutocompleteComponent } from './components/search-commande-autocomplete/search-commande-autocomplete.component';

/**
 * Les deux projets consultant et backoffice qui utilisent les assets de la lib ne passent pas par ce module mais importent directement  les composants dans leur module
 *  pour éviter de passer par un build intermediaire. Ce Module ne sert donc que pour avoir une compilation au niveau de la lib (utile pour les erreurs de codes)
 */
@NgModule({
  declarations: [
    UnauthorizedComponent,
    SafeResourceUrlPipe,
    StepperFooterComponent,
    SearchEnveloppeProduitAutocompleteComponent,
    ConfirmationSimpleComponent,
    LandingPageComponent,
    FicheConseilStatutTagComponent,
    NavPanelComponent,
    SearchCommandeAutocompleteComponent,
  ],
  exports: [
    SearchEnveloppeProduitAutocompleteComponent,
    DocumentViewerPanelComponent,
    StepperFooterComponent,
    FicheConseilStatutTagComponent,
    NavPanelComponent,
    SearchCommandeAutocompleteComponent,
  ],
  imports: [
    OuiLayoutModule,
    OuiIconModule,
    OuiButtonModule,
    OuiTabsModule,
    OuiTagModule,
    OuiTableModule,
    OuiPaginatorModule,
    OuiNavButtonModule,
    OuiNavigationPanelModule,
    OuiStepper,
    OuiSlideToggle,
    OuiSelect,
    OuiLoadingModule,
    OuiSelectFilter,
    OuiAccordionModule,
    OuiTextfield,
    OuiTextarea,
    OuiCheckbox,
    OuiAutocomplete,
    OuiButtonModule,
    OuiButtonToggle,
    OuiMenuModule,
    OuiSearchbar,
    OuiChipModule,
    OuiNumber,
    OuiBanner,
    OuiTooltipModule,
    OuiDialogModule,
    OuiSnackbarModule,
    OuiRadioButton,
    OuiRadioButtonGroup,
    OuiPairInfo,
    OuiEtatVide,
    OuiInfosBulle,
    OuiIconModule,
    MatDialogModule,
    MatSortModule,
    BrowserModule,
    BrowserAnimationsModule,
    OuiDialogModule,
    OuiErrorPageComponent,
    OuiDocumentViewer,
    DocumentViewerPanelComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class LibModule {}

registerLocaleData(localeFr, 'fr-FR');
